import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function initCustomEqType() {
  return request({
    url: URL.mdm.basicData.initCustomEqType,
    method: 'post'
  })
}

export function listCustomEqType(data) {
  return request({
    url: URL.mdm.basicData.listCustomEqType,
    method: 'post',
    data
  })
}

export function addCustomEqType(data) {
  return request({
    url: URL.mdm.basicData.addCustomEqType,
    method: 'post',
    data
  })
}

export function updateCustomEqType(data) {
  return request({
    url: URL.mdm.basicData.updateCustomEqType,
    method: 'post',
    data
  })
}

export function deleteCustomEqType(data) {
  return request({
    url: URL.mdm.basicData.deleteCustomEqType,
    method: 'post',
    data
  })
}
